// @flow
import React from "react";

type Props = {
  children: React$Node,
  pathname: string,
};

export class ScrollToTop extends React.Component<Props> {
  componentDidUpdate(oldProps: Props) {
    const { pathname } = this.props;
    if (oldProps.pathname !== pathname) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}
